// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

export type UpdatePhoneParameter = {
    phone: string;
};

const initialPhoneState: UpdatePhoneParameter = { phone: "" };

const xUpdatePhone = createTypedReducerWithImmer(initialPhoneState, {
    "Pages/AccountSettings/UpdatePhone": (draft: Draft<UpdatePhoneParameter>, action: { phone: string }) => {
        draft.phone = action.phone;
    },
});

(reducers as any).xUpdatePhone = xUpdatePhone;

export type xUpdatePhoneState = {
    xUpdatePhone: UpdatePhoneParameter;
} & ApplicationState;

type xUpdatePhoneReducers = {
    phone: typeof xUpdatePhone;
};

export type xUpdatePhoneActions = Parameters<xUpdatePhoneReducers[keyof xUpdatePhoneReducers]>[1] | AnyAction;
